import API from './api';

export default class CmsDashboard extends API {}
